// src/components/asset/AssetMediaDisplay.tsx

import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import Carousel from "../carousel/Carousel";
import { useAsset } from "../../context/AssetContext";

const AssetMediaDisplay: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const {
    clientId, assetId,
    visibleTypes, imageCategories
  } = useAsset();

  return (
    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
      {/* --- Native Carousels (No changes needed here) --- */}
      {imageCategories.map(({ key, label, images }) => {
        if (!visibleTypes[key] || images.length === 0) return null;
        
        const isUndercarriage =
          label.toLowerCase().includes("undercarriage") ||
          key.toLowerCase().includes("uc");
        const gridSize = isMobile ? 12 : (isUndercarriage && images.length > 1 ? 12 : 6);

        return (
          <Grid item xs={12} md={gridSize} key={key}>
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Typography variant="h6" gutterBottom>
                {label} Images
              </Typography>
              <Carousel assetId={assetId || ''} images={images} />
            </Box>
          </Grid>
        );
      })}

      {/* --- iFrame Previews --- */}

      {/* iFrame (All) */}
      <Grid item xs={12} md={6}> {/* On desktop, this will take up 6 columns */}
        <Typography variant="h6" gutterBottom>
          iFrame Preview (All)
        </Typography>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: isMobile ? '100%' : '75%',
          }}
        >
          <iframe
            src={`/iframe/${clientId}/${assetId}`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: "10px",
              border: "none",
              // The problematic minHeight has been removed.
            }}
            allow="fullscreen"
            allowFullScreen
          />
        </Box>
      </Grid>

      {/* iFrame (Exterior) */}
      <Grid item xs={12} md={6}> {/* On desktop, this will also take up 6 columns */}
        <Typography variant="h6" gutterBottom>
          iFrame Preview (Exterior)
        </Typography>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: isMobile ? '100%' : '75%',
          }}
        >
          <iframe
            src={`/iframe/${clientId}/${assetId}/ext-crop-feat`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: "10px",
              border: "none",
              // The problematic minHeight has been removed.
            }}
            allow="fullscreen"
            allowFullScreen
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default AssetMediaDisplay;